module.exports = __webpack_public_path__ + "9672074e6b68966af50106970547ab9f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/NG.svg
// module id = NuiH
// module chunks = 0